import { render, staticRenderFns } from "./magic_nav.vue?vue&type=template&id=362ab5c9&scoped=true"
import script from "./magic_nav.vue?vue&type=script&lang=js"
export * from "./magic_nav.vue?vue&type=script&lang=js"
import style0 from "./magic_nav.vue?vue&type=style&index=0&id=362ab5c9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362ab5c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('362ab5c9')) {
      api.createRecord('362ab5c9', component.options)
    } else {
      api.reload('362ab5c9', component.options)
    }
    module.hot.accept("./magic_nav.vue?vue&type=template&id=362ab5c9&scoped=true", function () {
      api.rerender('362ab5c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/custom-layout/components/centerModule/magic_nav.vue"
export default component.exports